<template>
    <span :title="longName">
        INSP-{{ inspection.InspectionDate | moment("YYYY-MM-DD") }}-JOB#{{ inspection.JobsiteNumber }}
    </span>
</template>

<script>
    export default {
        props: {
            inspection: {
                type: Object,
                required: true
            }
        },

        data: function() {
            return {

            }
        },

        computed: {
            longName: function() {
                return `${this.inspection.InspectionDate} - ${this.inspection.JobsiteNumber} - ${this.inspection.JobsiteName }`
            }
        },

        methods: {

        },

        mounted() {

        }
    }
</script>
